import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  placeholder: {
    width: '100%',
    height: '400px',
    backgroundColor: '#e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    flexDirection: 'column',
    gap: '12px',
  },
  message: {
    color: '#666',
    textAlign: 'center',
    padding: '0 20px',
    maxWidth: '400px',
  },
  errorIcon: {
    width: '48px',
    height: '48px',
    color: '#666',
  },
});